/**
 * vivre-filter-availability.js  v2
 * ─────────────────────────────────────────────────────────────────────────────
 * Auto-applies "In Stock" filter whenever size or colour filter is active.
 *
 * HOW TO INSTALL:
 * 1. Upload to Assets in your theme (Edit code → Assets → upload file)
 * 2. In sections/collection.liquid, just before {% schema %}, add:
 *    <script src="{{ 'vivre-filter-availability.js' | asset_url }}" defer></script>
 * ─────────────────────────────────────────────────────────────────────────────
 */

(function () {
  'use strict';

  const TRIGGER_NAMES = [
    'filter.v.option.size',
    'filter.v.option.colour',
    'filter.v.option.color',
  ];
  const AVAIL_PARAM = 'filter.v.availability';
  const AVAIL_VALUE = '1';

  // ── STEP 1: On every page load, check if URL has a trigger filter ──────────
  // If yes and availability isn't already in URL, redirect to add it silently.
  function syncOnLoad() {
    const p = new URLSearchParams(window.location.search);
    const hasTrigger = TRIGGER_NAMES.some(n => p.has(n));
    const hasAvail = p.get(AVAIL_PARAM) === AVAIL_VALUE;

    if (hasTrigger && !hasAvail) {
      p.set(AVAIL_PARAM, AVAIL_VALUE);
      // replace so back button still works naturally
      window.location.replace(window.location.pathname + '?' + p.toString());
      return true; // stop further execution, page is redirecting
    }

    // If no trigger filters active but availability is set, remove it
    if (!hasTrigger && hasAvail) {
      p.delete(AVAIL_PARAM);
      const newSearch = p.toString();
      window.location.replace(window.location.pathname + (newSearch ? '?' + newSearch : ''));
      return true;
    }

    return false;
  }

  // ── STEP 2: Intercept checkbox changes ────────────────────────────────────
  // When customer ticks/unticks a size or colour filter, also tick/untick
  // the In Stock checkbox before the theme fires its AJAX request.
  function attachListeners() {
    const form = document.querySelector('[data-collection-filters-form]');
    if (!form) return;

    form.addEventListener('change', function (e) {
      const input = e.target;
      if (!input || input.type !== 'checkbox') return;

      const isTrigger = TRIGGER_NAMES.includes(input.name);
      const isAvail = input.name === AVAIL_PARAM && input.value === AVAIL_VALUE;

      if (isTrigger) {
        setTimeout(function () {
          const anyTriggerChecked = TRIGGER_NAMES.some(function (n) {
            return form.querySelector('input[name="' + n + '"]:checked') !== null;
          });

          const availInput = form.querySelector(
            'input[name="' + AVAIL_PARAM + '"][value="' + AVAIL_VALUE + '"]'
          );
          if (!availInput) return;

          if (anyTriggerChecked && !availInput.checked) {
            availInput.checked = true;
            availInput.dispatchEvent(new Event('change', { bubbles: true }));
          } else if (!anyTriggerChecked && availInput.checked) {
            availInput.checked = false;
            availInput.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }, 10);
      }

      // If customer tries to manually untick In Stock while a trigger is active, re-tick it
      if (isAvail && !input.checked) {
        const anyTriggerChecked = TRIGGER_NAMES.some(function (n) {
          return form.querySelector('input[name="' + n + '"]:checked') !== null;
        });
        if (anyTriggerChecked) {
          setTimeout(function () { input.checked = true; }, 0);
        }
      }
    });
  }

  // Run on load first
  const redirecting = syncOnLoad();
  if (!redirecting) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', attachListeners);
    } else {
      attachListeners();
    }
  }

})();
